import Sequence from '@common/Sequence';
import type { CommandMethod, CommandRequestMap } from './StoresDispatcher';
import ToServer from './ToServer';
import type ApiState from '@api-client/state';

export type Pid = string;
export type TuneId = string;

type WorkerMessageApiState = CommandRequestMap[CommandMethod] | Partial<ApiState>;

export type PostMessage<TMethod extends string = string> = {
  tuneId: TuneId;
  method: TMethod;
  pid?: Pid;
  serverToApiType?: typeof Sequence.SERVER_TO_API_BROADCAST | typeof Sequence.SERVER_TO_API_EMIT
  apiState?: WorkerMessageApiState;
};

export type PostMessageWithoutPid = Omit<PostMessage, 'pid'>;

export type OnMessage = PostMessage;

export const statusTunning = 'tunning';
export const statusTuned = 'tuned';
export const statusUnTunning = 'untunning';
export const statusRequesting = 'requesting';
export const statusResponsing = 'responsing';
export const statusResponsed = 'responsed';
export const statusDispatching = 'dispatching';
export const statusDispatched = 'dispatched';
export type Status =
  | typeof statusTunning
  | typeof statusTuned
  | typeof statusUnTunning
  | typeof statusRequesting
  | typeof statusResponsing
  | typeof statusResponsed
  | typeof statusDispatching
  | typeof statusDispatched;

// MEMO: ワーカーはワーカーを生成できる
export default class WssWorker {
  toServer: ToServer;
  worker: Worker;
  constructor(worker: Worker) {
    this.onMessage = this.onMessage.bind(this);
    this.onMessageError = this.onMessageError.bind(this);
    this.postMessage = this.postMessage.bind(this);

    this.worker = worker;
    this.worker.onerror = this.onMessageError;
    this.worker.onmessage = this.onMessage;
    this.toServer = new ToServer(this);
  }

  public postMessage({ pid, tuneId, method, serverToApiType, apiState }: PostMessage): void {
    if (tuneId && method) {
      this.worker.postMessage({ pid, tuneId, method, serverToApiType, apiState });
    }
  }

  private onMessage(e: MessageEvent): void {
    const { pid, tuneId, method, serverToApiType, apiState }: OnMessage = e.data;
    if (tuneId && method && apiState) {
      this.toServer.exe(pid, tuneId, method, apiState);
    }
  }

  private onMessageError(e: ErrorEvent): void {
    console.warn(e);
  }
}

// WebWorkerコンテキストでは、selfはWorkerGlobalScopeとして利用可能
new WssWorker(self as unknown as Worker);
